<template>
  <nav class="nav-bar-desktop">
    <NavLink
      v-for="(page, i) of pageLinks"
      :class="[
        'nav-bar-desktop__link',
        {
          left: i <= currentPageIndex,
          animating:
            animating &&
            (animatingToLeft ? i > currentPageIndex : i < currentPageIndex),
        },
      ]"
      :style="{
        '--link-index': i,
        '--amount-links': pageLinks.length,
      }"
      :key="page"
      :currentPage="currentPage"
      :page="page"
    />
  </nav>
</template>

<script setup>
import { computed, watch, ref } from "vue";

import NavLink from "./NavLink.vue";

const props = defineProps({
  pageLinks: {
    type: Array,
    default: () => [],
  },
  currentPage: String,
});

// True as long as page animation is going on
const animating = ref(false);
const animatingToLeft = ref(true);

const currentPageIndex = computed(() =>
  props.pageLinks.indexOf(props.currentPage)
);

watch(
  () => props.currentPage,
  (prev, current) => {
    animatingToLeft.value =
      props.pageLinks.indexOf(current) > props.pageLinks.indexOf(prev);
    animating.value = true;

    setTimeout(() => {
      animating.value = false;
    }, 2000);
  }
);
</script>

<style lang="scss" scoped>
.nav-bar-desktop {
  --link-size: #{toRem(30)};

  position: fixed;
  top: 0;
  right: 0;
  z-index: 5;

  &__link {
    --left-translate: var(--vw-no-scrollbar, 100vw) * -1 + var(--amount-links) *
      100%;

    transition: transform 0s 1.5s, opacity 0.5s, background-color 0.5s,
      color 0.5s;

    &.animating {
      opacity: 0;
    }

    &.left {
      transform: translateX(calc(var(--left-translate)));

      &:last-child {
        visibility: hidden;
      }
    }
  }
}
</style>
